import Vue from 'vue'
window.Vue = Vue

import CityStateSelector from './components/payments/CityStateSelector.vue';

import moment from "moment"
window.moment = moment

import formatPrice from './utils/formatPrice'

Vue.component('city-state-selector', CityStateSelector);

import parseUrlInContent from "./utils/parseUrlInContent";
import nl2br from "./utils/nl2br";

var EventApp = {
    data: {},
    boot() {
        $(document).on("keypress", ":input:not(textarea)", function(event) {
            if (event.keyCode == 13) {
                event.preventDefault();
            }
        });
    },
    methods: {
        utils: {
            formatPrice: formatPrice
        },
        modalText(text) {
            text = parseUrlInContent(text)
            text = nl2br(text)
            return text
        }
    }
}
EventApp.boot()
window.EventApp = EventApp

